/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditMentionsAuditMentionsDateSchedulesCsvImportMutationResponse, AuditMentionsAuditMentionsDateSchedulesCsvImportQueryParams } from "../models/AuditMentionsAuditMentionsDateSchedulesCsvImport";

export function getAuditMentionsAuditMentionsDateSchedulesCsvImportUrl() {
  const res = { method: 'POST', url: `/audit-mentions/v1/date-schedules/csv-import` as const }
  return res
}

/**
 * @description Imports mention date schedules from a CSV file.
 * @summary Import mention date schedules from CSV
 * {@link /audit-mentions/v1/date-schedules/csv-import}
 */
export async function auditMentionsAuditMentionsDateSchedulesCsvImport(params: AuditMentionsAuditMentionsDateSchedulesCsvImportQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditMentionsAuditMentionsDateSchedulesCsvImportMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getAuditMentionsAuditMentionsDateSchedulesCsvImportUrl().url.toString(), params, ... requestConfig })
  return res.data
}